import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface DraftReportState {
  matchingCode: any[];
  notMatchingCode: any[];
  scannedCodes: string[];
}

const initialState: DraftReportState = {
  matchingCode: [],
  notMatchingCode: [],
  scannedCodes: [],
};

const stockDataSlice = createSlice({
  name: 'stockReport',
  initialState,
  reducers: {
    saveDraft: (
      state,
      action: PayloadAction<{
        matchingCode: any[];
        notMatchingCode: any[];
        scannedCodes: string[];
      }>,
    ) => {
      state.matchingCode = action.payload.matchingCode;
      state.notMatchingCode = action.payload.notMatchingCode;
      state.scannedCodes = action.payload.scannedCodes;
    },
    clearDraft: (state) => {
      state.matchingCode = [];
      state.notMatchingCode = [];
      state.scannedCodes = [];
    },
  },
});

export const { saveDraft, clearDraft } = stockDataSlice.actions;
export default stockDataSlice.reducer;
